import React from 'react';
import type { Tax } from 'src/App/generated/graphql-types';
import { TaxSuffix } from '@seek/tax-suffix';
import type { Locale } from '@seek/melways-sites';

export const TaxWrapper = ({
  locale,
  tax,
  children,
}: {
  locale: Locale;
  tax?: Tax;
  children?: React.ReactNode;
}) => {
  if (tax && tax.displayRecommendation) {
    return (
      <TaxSuffix
        taxCode={tax.code}
        locale={locale}
        displayRecommendation={tax.displayRecommendation}
        flexDirection="row"
      >
        {children}
      </TaxSuffix>
    );
  }

  return children;
};
